import axios from 'axios';
import { getGlobalStore } from '@/lib/global-store';
class SlackWebHook {
    store;
    webHookUrl = process.env.VUE_APP_SLACK_WEB_HOOK;
    constructor() {
        this.store = getGlobalStore();
    }
    _send(logName, extraMessage, emoji) {
        const message = `${emoji} START ========>
*CreatedAt:* ${new Date()}
*Version:* ${process.env.VUE_APP_VERSION}
*UserAgent:* ${window.navigator.userAgent}
*URL:* ${window.location.href}
*Log:*
${extraMessage}
*UserInfo:*
${JSON.stringify(this.store.state.user.userInfo, null, '\t')}
*HubInfo:*
${JSON.stringify(this.store.state.user.hubInfo, null, '\t')}
                          <======== END`;
        const payload = {
            username: logName,
            icon_emoji: emoji,
            text: message,
        };
        axios({
            method: 'post',
            url: this.webHookUrl,
            headers: {
                'Content-Type': 'text/plain',
            },
            data: JSON.stringify(payload),
        });
    }
    // 언핸들에러 -> 우리가 핸들링하지 않은 에러
    sendUnhandledError(err, info) {
        const emoji = ':fire:';
        const message = `*Error Info:* ${info}
*Error Log:* ${err.toString()}
*Error Stack:*
${err.stack}`;
        this._send('UnhandledError', message, emoji);
    }
    // 단순로그. -> 에러가 아님
    sendLog(payload) {
        const emoji = ':pencil2:';
        this._send('Log', JSON.stringify(payload), emoji);
    }
}
export default new SlackWebHook();
